<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="7" @click="toNewRouter('water-over-view')" v-if="permissionCodes.indexOf('027001000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-submenu index="1" v-if="permissionCodes.indexOf('027002000') !== -1 || permissionCodes.indexOf('027002004') !== -1">
        <template slot="title">
          <i class="el-icon-damai-shebei2"></i>
          <span>设备管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1" @click="toNewRouter('water-controller-management')" v-if="permissionCodes.indexOf('027002000') !== -1">集中器管理</el-menu-item>
          <el-menu-item index="1-2" @click="toNewRouter('water-ammeter-management')" v-if="permissionCodes.indexOf('027002004') !== -1">水表管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!--<el-menu-item index="5" @click="toNewRouter('water-account-center')" v-if="permissionCodes.indexOf('004002000') !== -1">-->
        <!--<i class="el-icon-damai-page_shoukuanzhanghu" style="font-size: 20px;"></i>-->
        <!--<span slot="title">收款账户配置</span>-->
      <!--</el-menu-item>-->
      <el-submenu index="2" v-if="permissionCodes.indexOf('027003000') !== -1 || permissionCodes.indexOf('027004000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-menjinquanxianfenpei"></i>
          <span>用水配置</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="2-1" @click="toNewRouter('water-config-center')" v-if="permissionCodes.indexOf('027003000') !== -1">收费配置</el-menu-item>
          <el-menu-item index="2-2" @click="toNewRouter('water-device-scene-config')" v-if="permissionCodes.indexOf('027004000') !== -1">场景配置</el-menu-item>
          <el-menu-item index="2-3" @click="toNewRouter('water-config-settle')" v-if="permissionCodes.indexOf('027004005') !== -1">结算配置</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="5" v-if="permissionCodes.indexOf('027005000') !== -1 || permissionCodes.indexOf('027006000') !== -1">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span slot="title">用水统计</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="5-1" @click="toNewRouter('water-quantity')" v-if="permissionCodes.indexOf('027005000') !== -1">按水表统计</el-menu-item>
          <el-menu-item index="5-2" @click="toNewRouter('water-quantity-public')" v-if="permissionCodes.indexOf('027006000') !== -1">按承租主体统计</el-menu-item>
          <el-menu-item index="5-3" @click="toNewRouter('water-quantity-room')" v-if="permissionCodes.indexOf('027005000') !== -1">按房间统计</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="10" @click="toNewRouter('water-monitoring')" v-if="permissionCodes.indexOf('027012000') !== -1">
        <i class="el-icon-damai-ic_shuiliangjiance"></i>
        <span slot="title">水表读数</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('water-rent-money')" v-if="permissionCodes.indexOf('027007000') !== -1">
        <i class="el-icon-damai-jiaofeijilu"></i>
        <span slot="title">余额管理</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('water-pay-record')" v-if="permissionCodes.indexOf('027008000') !== -1">
        <i class="el-icon-damai-page_shoukuanzhanghu" style="font-size: 20px;"></i>
        <span slot="title">充值记录</span>
      </el-menu-item>
      <el-menu-item index="9" @click="toNewRouter('water-settlement-record')" v-if="permissionCodes.indexOf('027009000') !== -1">
        <i class="el-icon-damai-jiesuantongji"></i>
        <span slot="title">结算记录</span>
      </el-menu-item>
      <el-menu-item index="8" @click="toNewRouter('water-controller-device-status-log')" v-if="permissionCodes.indexOf('027010000') !== -1">
        <i class="el-icon-damai-zhuangtairizhi"></i>
        <span slot="title">设备状态日志</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('water-control-log')" v-if="permissionCodes.indexOf('027011000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  "1-1": [
    "water-controller-management",
    "water-controller-add",
    "water-controller-modify",
    "water-controller-current"
  ],
  "1-2": [
    "water-ammeter-management",
    "water-ammeter-add",
    "water-ammeter-modify",
    "water-ammeter-current"
  ],
  "2-1": ["water-config-center", "water-config-modify"],
  "2-2": "water-device-scene-config",
  "2-3": "water-config-settle",
  3: "water-pay-record",
  4: "water-rent-money",
  // '5': ['water-account-center', 'water-account-modify'],
  "5-1": "water-quantity",
  "5-2": "water-quantity-public",
  "5-3": "water-quantity-room",
  6: "water-control-log",
  7: "water-over-view",
  8: "water-controller-device-status-log",
  9: "water-settlement-record",
  10: "water-monitoring"
});

export default {
  name: "investment-leasing-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/WaterManage/WaterManagementNav.vue